import React, { useState, useEffect } from "react";
import "./Careers.scss";

import axios from "axios";

import JobView from "./JobView";

import {
  Spinner,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
} from "@chakra-ui/react";
import {
  Search2Icon,
  ArrowForwardIcon,
  WarningIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";

const CAREER_WELCOME_TEXT = "Welcome to Workoza Career Center";
const CAREER_SEARCH_TEXT =
  "Please enter required keywords based on your specific career interests";
const SEARCH_PLACEFOLDER = "Search job using keywords";
const EMPTY_STATE_TEXT = "No jobs available!";
const ALL_AVAILABLE_JOB_TEXT = "All available job results";

const Careers = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [allJobs, setAllJobs] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchAllJobs = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `https://workoza-server-vercel.vercel.app/api/job`
        );
        setAllJobs(res?.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllJobs();
  }, []);

  const renderCareerTopbar = () => {
    const handleSearchTextChange = (e) => {
      setSearchText(e?.target?.value);
    };

    const handleSearchJobClick = async () => {
      try {
        setIsLoading(true);
        if (searchText) {
          const res = await axios.get(
            `https://workoza-server-vercel.vercel.app/api/job/filter`,
            {
              params: {
                title: searchText,
                location: searchText,
                jobId: searchText,
                jobType: searchText,
                jobStatus: searchText,
              },
            }
          );
          setAllJobs(res?.data);
        } else {
          const res = await axios.get(
            `https://workoza-server-vercel.vercel.app/api/job`
          );
          setAllJobs(res?.data);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div className="careerTopBarContainer">
        <div className="careerTopBarMainText">{CAREER_WELCOME_TEXT}</div>
        <div className="careerTopBarBottomContainer">
          <div className="careerTopBarMainSubText">{CAREER_SEARCH_TEXT}</div>
          <div className="careerTopBarSearchInputContainer">
            <div className="careersInputWrapper">
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<Search2Icon color="#717171" />}
                />
                <Input
                  type="search"
                  variant={"filled"}
                  focusBorderColor="#d33852"
                  placeholder={SEARCH_PLACEFOLDER}
                  _placeholder={{ color: "#717171" }}
                  value={searchText}
                  onChange={handleSearchTextChange}
                />
              </InputGroup>
            </div>
            <Button
              rightIcon={<ArrowForwardIcon />}
              size="md"
              variant="solid"
              color="#ffffff"
              background="#d33853"
              _hover={{ background: "#af273e", color: "#f9f9f9" }}
              onClick={handleSearchJobClick}
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const renderCareerFeed = () => {
    const isJobsAvailable = allJobs.length;

    const renderAllJobsFeed = () => {
      const renderAllJobs = () => {
        return allJobs?.map((jobDetails, index) => {
          return (
            <JobView
              jobDetails={jobDetails}
              jobIndex={index}
              key={jobDetails?._id}
            />
          );
        });
      };

      return <div className="careerAllJobsWrapper">{renderAllJobs()}</div>;
    };

    return isLoading ? (
      <div className="careerLoadingContainer">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="#717171"
          color="#d33853"
          size="lg"
        />
      </div>
    ) : isJobsAvailable > 0 ? (
      <div className="careerFeedAllJobs">
        <div className="careerAllAvailableJobText">
          {ALL_AVAILABLE_JOB_TEXT}
          <ChevronRightIcon w={8} h={8} />
        </div>
        {renderAllJobsFeed()}
      </div>
    ) : (
      <div className="careerFeedEmptyStateContainer">
        <div className="careerFeedEmptyStateText">
          <WarningIcon />
          {EMPTY_STATE_TEXT}
        </div>
      </div>
    );
  };

  return (
    <div className="careerContainer">
      <div className="careerWrapper">
        {renderCareerTopbar()}
        {renderCareerFeed()}
      </div>
    </div>
  );
};

export default Careers;
